export default __webpack_public_path__ + "static/media/SerialTek_Master_Logo_PNG.715e380f.png";